var map = {
	"./Outlined_pieces/Octopus@4x.webp": 6644,
	"./Outlined_pieces/firstfloor@4x.webp": 2673,
	"./Outlined_pieces/secondfloor@4x.webp": 8157,
	"./Outlined_pieces/sun.webp": 107,
	"./Outlined_pieces/treasure.webp": 7314,
	"./bg-mobile-notext.webp": 3713,
	"./bg-mobile.webp": 4218,
	"./bg-notext.webp": 8087,
	"./bg.webp": 8021,
	"./bgDesktop.webp": 4231,
	"./bgMobile.webp": 2435,
	"./bgTablet.webp": 4361,
	"./books1.webp": 9347,
	"./books2.webp": 8626,
	"./brains1.webp": 1034,
	"./brains2.webp": 4235,
	"./brains3.webp": 1432,
	"./deck1.webp": 2126,
	"./desktop_top.webp": 966,
	"./door1.webp": 7661,
	"./door2.webp": 9008,
	"./door3.webp": 3091,
	"./eyes1.webp": 5799,
	"./eyes2.webp": 326,
	"./eyes3.webp": 9201,
	"./eyes4.webp": 2376,
	"./face1.webp": 286,
	"./face2.webp": 9983,
	"./face3.webp": 8396,
	"./face4.webp": 4589,
	"./garden1.webp": 7514,
	"./glass1.webp": 2853,
	"./glass2.webp": 3928,
	"./glass3.webp": 9275,
	"./glass4.webp": 1878,
	"./horse1.webp": 4882,
	"./horse2.webp": 6579,
	"./horse3.webp": 6144,
	"./interior1.webp": 785,
	"./interior2.webp": 3444,
	"./interior3.webp": 5303,
	"./lights1.webp": 2242,
	"./lights2.webp": 7587,
	"./lights3.webp": 3504,
	"./main1.webp": 9374,
	"./mermaid1.webp": 6936,
	"./mermaid2.webp": 9365,
	"./mermaid3.webp": 7498,
	"./mermaid4.webp": 6983,
	"./moroccan1.webp": 7339,
	"./mother1.webp": 4192,
	"./mother2.webp": 8861,
	"./mother3.webp": 3298,
	"./painter1.webp": 2156,
	"./painter2.webp": 1081,
	"./sacred1.webp": 7157,
	"./sacred2.webp": 8376,
	"./sacred3.webp": 4635,
	"./sacred4.webp": 518,
	"./throne1.webp": 9535,
	"./throne2.webp": 894,
	"./tiling1.webp": 2804,
	"./tiling2.webp": 3441,
	"./tub1.webp": 2056,
	"./water1.webp": 2192,
	"./water2.webp": 845,
	"./water3.webp": 930
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8735;